// Tâche 1451 (Eric 2026-06) — Les formats d'import vidéo et audio, à UN seul
// endroit.
//
// ⚠️ DÉFAUT TROUVÉ EN BRANCHANT LE JOURNAL DES REFUS : l'écran d'import
// refusait dans le navigateur une liste PLUS COURTE que celle du serveur
// (mp4|mov|avi|webm|mp3|wav|m4a|aac). Un .mkv, un .wmv, un .flv, un .m4v, un
// .ts, un .mpg, un .3gp, un .ogg, un .flac ou un .wma était donc refusé AVANT
// l'envoi alors que le serveur les accepte — et le message disait « format non
// supporté », ce qui est faux. La liste ci-dessous est celle du serveur
// (`routers/videos.py`) ; l'attribut `accept` en est dérivé pour que les deux
// ne puissent plus diverger.
export const EXTENSIONS_VIDEO = [
  ".mp4", ".mov", ".avi", ".webm", ".mkv", ".wmv", ".flv", ".m4v",
  ".ts", ".mpg", ".mpeg", ".3gp",
];

export const EXTENSIONS_AUDIO = [
  ".mp3", ".wav", ".m4a", ".aac", ".ogg", ".flac", ".wma",
];

export const EXTENSIONS_MEDIA = [...EXTENSIONS_VIDEO, ...EXTENSIONS_AUDIO];

export const ACCEPT_MEDIA = `video/*,audio/*,${EXTENSIONS_MEDIA.join(",")}`;

export const LISTE_MEDIA = EXTENSIONS_MEDIA
  .map((e) => e.slice(1).toUpperCase())
  .join(", ");

export function estAudio(nom) {
  const bas = (nom || "").toLowerCase();
  return EXTENSIONS_AUDIO.some((e) => bas.endsWith(e));
}

export function extensionAcceptee(nom) {
  const bas = (nom || "").toLowerCase();
  return EXTENSIONS_MEDIA.some((e) => bas.endsWith(e));
}

export default EXTENSIONS_MEDIA;
